<template>
    <div v-if="showLegalBar" class="ml-auto" :class="{ 'pt-2': location !== 'WizardHeader' }">
        <router-link class="d-flex underline" :class="legalText" :to="legalLink" target="_blank">
            {{ legalLabel }}
        </router-link>
    </div>
</template>

<script>
import { useStore } from 'vuex'
import { url } from '@js/utilities/url.js'

// lodash components
import trimStart from 'lodash/trimStart'

export default {
    props: ['location'],
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    computed: {
        legalLink: function () {
            if (this.store.state.global.data.legal_text_link) {
                //ensure we dont double up on //
                return url(`/${trimStart(this.store.state.global.data.legal_text_link, '/')}`)
            }
            return null
        },
        legalLabel: function () {
            return this.store.state.global.data.legal_text_label
        },
        showLegalBar: function () {
            return this.legalLink && this.legalLabel
        },
        legalText: function () {
            if (this.location === 'WizardHeader') {
                return 'legal-text-wizard'
            }

            return 'legal-text'
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.legal-text {
    font-size: 0.8rem;
    color: var(--hero-text);

    &-wizard {
        font-size: 0.8rem;
        color: var(--wizard-back-button-color);
    }
}

a.underline {
    text-decoration: underline;
}
</style>
